import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const Warning: React.FC<SvgProps> = (props) => {
  return (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M9.44519 3.02841C10.5806 1.06174 13.4201 1.06174 14.5555 3.02841L21.9091 15.7765H21.91C23.0437 17.7429 21.624 20.2002 19.3553 20.2003H4.64538C2.37597 20.2003 0.955602 17.7433 2.0907 15.7765L9.44519 3.02841ZM13.3426 3.72763C12.7459 2.69478 11.2537 2.69461 10.6571 3.72763L3.30359 16.4757C2.70714 17.5088 3.45297 18.7999 4.64538 18.7999H19.3553C20.5463 18.7998 21.293 17.5091 20.6971 16.4757L13.3426 3.72763ZM12.0067 15.0499C12.3933 15.0499 12.7069 15.3635 12.7069 15.7501V15.7579C12.7069 16.1445 12.3933 16.4581 12.0067 16.4581H11.9999C11.6134 16.4579 11.3007 16.1444 11.3007 15.7579V15.7501C11.3007 15.3636 11.6134 15.0501 11.9999 15.0499H12.0067ZM11.3007 12.7501V9.00009C11.3007 8.6136 11.6134 8.30006 11.9999 8.2999C12.3865 8.2999 12.7001 8.61349 12.7001 9.00009V12.7501C12.7 13.1367 12.3865 13.4503 11.9999 13.4503C11.6134 13.4501 11.3007 13.1366 11.3007 12.7501Z"
        fill="currentColor"
      />
    </Icon>
  )
}
